import React from 'react';
import {
  arrayOf, bool, number, shape, string
} from 'prop-types';
import { SalientListItem } from '@thd-olt-component-react/salient-points';
import './attribute-list.scss';

export const AttributeList = ({
  attributes, careDescription, description, heading, plain
}) => {

  return (
    <>
      {heading && <h4 className="attribute-list__heading">{heading}</h4>}
      {description && <p className="attribute-list__description">{description}</p>}
      {careDescription && <p>{careDescription}</p>}
      {(attributes || []).map((attribute, attributeIndex) => {
        if (plain) {
          return <p key={attributeIndex}>{ attribute.value }</p>;
        }
        return (
          <SalientListItem
            className="collection-info-tabs__list-item"
            key={attributeIndex}
          >
            {attribute.value}
          </SalientListItem>
        );
      })}
    </>
  );
};

AttributeList.displayName = 'AttributeList';

AttributeList.propTypes = {
  attributes: arrayOf(shape({
    bulleted: bool, // ignored :shrug:
    name: string, // ignored
    sequence: number,
    value: string
  })).isRequired,
  careDescription: string,
  description: string,
  heading: string,
  plain: bool
};

AttributeList.defaultProps = {
  careDescription: null,
  description: null,
  heading: null,
  plain: false
};
